import React, {useEffect} from "react"
import EquimentSelectComponent from "./EquimentSelectComponent";
// import SelectConfLevelComponent from "./SelectConfLevelComponent";

export default function StepFourComponent({project, equipmentData, updateProject, updateProjectWithNewLevel, trackingObj, isIFrame}){
    useEffect(() => {
        if (!isIFrame) { setTimeout(() => {document.body.style.overflow = 'unset'; }, 200); }
    }, []);
    function setConfLevel(e, level){
        e.stopPropagation();
        updateProjectWithNewLevel({...project, selectedLevel: level});
    }

    return <div>
        <div className="fs-container ptb-25 mt-15">
            {project.projectType !== 'konventionell' ? <>
                    <div className="padding-container">
                        <div className="section-title">Weitere Ausstattung der Gebäudesteuerung wählen</div>
                        <div className="section-text mb-15">Welche Funktionen in Ihrem Smart Home sind für Sie wichtig?<br/>Die
                            dazu notwendigen Komponenten können Sie in der Produktliste auf nächster Seite nachlesen.
                        </div>
                    </div>
                </>
                : <>
                    <div className="padding-container">
                        <div className="section-title">Weitere Ausstattung auswählen</div>
                        <div className="section-text mb-15">Welche Funktionen in Ihrem Zuhause sind für Sie wichtig?<br/>Die
                            dazu notwendigen Komponenten können Sie in der Produktliste auf nächster Seite nachlesen.
                        </div>
                    </div>
                </>
            }
        </div>
        { equipmentData.map( (item, idx) => <EquimentSelectComponent project={project} equipmentData={item} updateProject={updateProject} key={item.id} opened={window.innerWidth > 800} setLevel={setConfLevel} starsClickable={false} allowClose={false} noArrow={true} noStars={true} withPadding={true} />)}
    </div>
}
